import { PkToast, PkToastItem } from '@uefadigital/panenka-react';
import dayjs from 'dayjs';
import { memo } from 'react';

import { useLocalStorage } from '@shared/hooks/useLocalStorage';
import { useTranslateFn } from '@shared/Translate';
import { language } from '@utilities/browser';

import * as styles from './styles.module.scss';

const Message = () => {
  const t = useTranslateFn();
  const [dismissed, setDismissed] = useLocalStorage<dayjs.Dayjs>('uefatvdismissed', null);

  const handleDismiss = () => {
    setDismissed(dayjs());
  };
  if (language === 'en' || (dismissed && dayjs().diff(dismissed, 'day') < 7)) return null;

  return (
    <PkToast pk-theme='light' className={styles.container}>
      <PkToastItem closeButton autodismiss={false} className='pk-rounded--xl' onPkDismiss={handleDismiss}>
        <div className='pk-mr--m' slot='body'>
          {t('uefatv_notavailable_msg')}
        </div>
      </PkToastItem>
    </PkToast>
  );
};

export default memo(Message);
